









































































































































































import CoSelect from '@/components/Molecules/co-select/CoSelect.vue';
import CoMultiSelect from '@/components/Molecules/co-multiselect/CoMultiSelect.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import axios from 'axios';
import { get, map, uniq, cloneDeep, values, set } from 'lodash';
import {
    Rule,
    OperatorOptions,
    EQ,
    NEQ,
    GT,
    GTE,
    LT,
    LTE,
    LIKE,
    NOTLIKE,
    BETWEEN,
    ANY,
    ConditionField,
    AccessCondition,
    AccessConditionGroup,
} from './models.ts';

export default {
    name: 'CoRules',
    components: {
        CoSelect,
        CoMultiSelect,
        CoButton,
        CoRoundButton,
    },
    props: {
        rules: {
            type: Object as () => Rule,
            default: () => ({}),
        },
    },
    data() {
        return {
            // You can add any local state here if needed
            rulesToModify: this.rules as Rule,
            rerenderKey: 0, // Used to force re-render if needed

            availablePlans: [], // list of available membership plans
        };
    },
    watch: {
        rules: {
            handler(newRules) {
                this.getAllPlans(); // Fetch all plans when rules change

                // Clone the rules to modify them without affecting the original
                this.rulesToModify = cloneDeep(newRules);
                // iterate over groups and then conditions and fetch users for each condition
                this.rulesToModify.ConditionsGroups.forEach((group) => {
                    group.Conditions.forEach((condition) => {
                        if (condition.Field === 'user_id' && condition.Values?.length > 0) {
                            this.fetchUsersForCondition(condition);
                        }
                        if (condition.Field === 'user_role' && condition.Values?.length > 0) {
                            condition.PrefetchedValues = values(condition.Values).map((role) => ({
                                Name: this.$t(`labels.roles.${role}`),
                                Value: role,
                            }));
                        }
                    });
                });
            },
            deep: true,
        },
        rulesToModify: {
            handler(newRules) {
                // Emit the modified rules to the parent component
                this.$emit('update', newRules);
                // this.rerenderKey += 1; // Force re-render to update the UI
            },
            deep: true,
        },
    },
    computed: {
        operators() {
            return Object.values(OperatorOptions).map((op) => ({
                value: op,
                label: this.$t(`labels.rules.operators.${op}`),
            }));
        },
        conditionFields() {
            const fields = {
                user_id: this.$t('labels.rules.fields.user_id'),
                plan_id: this.$t('labels.rules.fields.plan_id'),
                user_role: this.$t('labels.rules.fields.user_role'),
                // user_status: this.$t('labels.rules.fields.user_status'),
                // user_email: this.$t('labels.rules.fields.user_email'),
            };
            return fields;
        },
    },
    mounted() {
        // You can perform any setup logic here if needed
        this.getAllPlans(); // Fetch all plans on mount
        // iterate over groups and then conditions and fetch users for each condition
        this.rulesToModify.ConditionsGroups.forEach((group) => {
            group.Conditions.forEach((condition) => {
                if (condition.Field === 'user_id' && condition.Values?.length > 0) {
                    this.fetchUsersForCondition(condition);
                }
                if (condition.Field === 'user_role' && condition.Values?.length > 0) {
                    condition.PrefetchedValues = values(condition.Values).map((role) => ({
                        Name: this.$t(`labels.roles.${role}`),
                        Value: role,
                    }));
                }
            });
        });
    },
    methods: {
        //
        setConditionValueForUserRole(condition: AccessCondition, $event: any) {
            condition.Values = $event.map((i) => i.Value);
            condition.PrefetchedValues = $event;
        },
        setConditionValueForPlanID(condition: AccessCondition, $event: any) {
            condition.Values = $event.map((i) => i.Value);
            condition.PrefetchedValues = $event;
        },
        prefillPlansInCondition() {
            this.rulesToModify.ConditionsGroups.forEach((group) => {
                group.Conditions.forEach((condition) => {
                    if (condition.Field === 'plan_id' && condition.Values?.length > 0) {
                        condition.PrefetchedValues = this.availablePlans.filter((plan) =>
                            condition.Values.includes(plan.Value)
                        );
                        this.rerenderKey += 1; // Force re-render to update the UI
                    }
                    this.rerenderKey += 1; // Force re-render to update the UI
                });
            });
        },
        getAllPlans() {
            // Fetch all plans from the server
            axios({
                method: 'GET',
                url: '/admin/plan/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const planList = get(response, 'data.Plans', []);
                    this.availablePlans = planList.map((plan) => ({
                        Name: plan.Name,
                        Value: plan.ID,
                        ThumbnailImageURL: plan.ImageURL || '',
                        ShowThumbnail: true,
                    }));
                    this.prefillPlansInCondition();
                })
                .catch((error) => {
                    console.error('Error fetching plans:', error);
                });
        },
        setConditionValueForUserID(condition: AccessCondition, $event: any) {
            condition.Values = $event.map((i) => i.Value);
            condition.PrefetchedValues = $event;
        },
        fetchUsersForCondition(condition: AccessCondition) {
            let userIDs = condition.Values || [];
            userIDs = uniq(userIDs);
            // get the users
            axios({
                method: 'POST',
                url: '/user/listbyids',
                data: {
                    IDS: map(userIDs, (i) => ({ ID: i })),
                },
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const objects = get(response, 'data.Users', []);
                    const prefetchedValues = objects.map((user: any) => ({
                        Name: get(user, 'Profile.Name', 'Unknown User'),
                        Value: user.ID,
                        Disabled: false,
                        ShowThumbnail: true,
                        RoundThumbnail: true,
                        ThumbnailImageURL: get(user, 'Profile.ImageURL', ''),
                    }));
                    // Instead of assigning to parameter, emit or update via Vue reactivity
                    condition.PrefetchedValues = prefetchedValues;
                    this.rerenderKey += 1; // Force re-render to update the UI
                })
                .catch((error) => {
                    this.rerenderKey += 1; // Force re-render to update the UI
                    console.error('Error fetching users:', error);
                });
        },
        searchUsers(query: string, source: any) {
            return new Promise((resolve, reject) => {
                // exit if query is less than 2 characters
                if (!query || query.length < 2) {
                    resolve([]);
                    return;
                }
                axios({
                    method: 'GET',
                    url: `/admin/member/search/${query}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    cancelToken: source ? source.token : null,
                })
                    .then((response) => {
                        const objects = get(response, 'data.objects', []);
                        const output = objects.map((user: any) => ({
                            Name: get(user, 'object.Profile.Name', 'Unknown User'),
                            Value: user.object.ID,
                            Disabled: false,
                            ShowThumbnail: true,
                            RoundThumbnail: true,
                            ThumbnailImageURL: get(user, 'object.Profile.ImageURL', ''),
                        }));
                        resolve(output);
                    })
                    .catch((error) => {
                        console.error('Error fetching users:', error);
                        reject(error);
                    });
            });
        },
        addNewGroup() {
            this.rulesToModify.ConditionsGroups.push({
                Conditions: [
                    {
                        Field: 'user_id',
                        Operator: EQ,
                        Values: [],
                    },
                ],
                CombineWithOR: false,
            });
        },
        addCondition(rule: AccessConditionGroup, condIndex: number) {
            rule.Conditions.push({
                Field: 'user_id',
                Operator: EQ,
                Values: [],
            });
        },
        removeCondition(rule: AccessConditionGroup, condIndex: number) {
            rule.Conditions.splice(condIndex, 1);
            if (rule.Conditions.length === 0) {
                this.rulesToModify.ConditionsGroups.splice(this.rulesToModify.ConditionsGroups.indexOf(rule), 1);
            }
        },
        changeGroupConditionType(rule: AccessConditionGroup, type: 'AND' | 'OR') {
            rule.CombineWithOR = type === 'OR';
        },
        operatorsForField(field: ConditionField) {
            switch (field) {
                case 'user_id':
                case 'plan_id':
                case 'user_status':
                case 'user_role':
                    return {
                        EQ: this.$t('labels.rules.operators.EQ'),
                        NEQ: this.$t('labels.rules.operators.NEQ'),
                        ANY: this.$t('labels.rules.operators.ANY'),
                    };
                default:
                    return [];
            }
        },
        // You can add methods to handle any specific logic related to rules
        optionsForField(field: string, value: string) {
            switch (field) {
                case 'user_id':
                    return this.getUsers(value);
                case 'plan_id':
                    return this.getPlans(value);
                case 'user_role':
                    return this.getUserRoles(value);
                case 'user_status':
                    return this.getUserStatuses(value);
                default:
                    return [];
            }
        },
        getUsers(input: string) {
            return [];
        },
        getPlans(input: string) {
            return [];
        },
        getUserRoles(input: string) {
            return [];
        },
        getUserStatuses(input: string) {
            return [];
        },
    },
};
